import { ClockClockwiseIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const TimeMachine = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ClockClockwiseIcon size={Sizes[size]} {...rest} color={fill} />;
};

TimeMachine.displayName = 'TimeMachine';
